// Cambia el ícono de la pestaña del navegador al logo de la empresa (base64).
// Si no hay logo válido, no toca nada y se queda el ícono genérico por defecto
// (frontend/public/favicon-default.png, ya referenciado en index.html).
export function setFaviconFromLogo(logoBase64) {
  if (!logoBase64 || typeof logoBase64 !== 'string') return;
  try {
    const link = document.getElementById('app-favicon');
    if (!link) return;
    link.href = `data:image/png;base64,${logoBase64}`;
  } catch {
    // Cualquier error (base64 inválido, etc.) deja el favicon por defecto tal cual.
  }
}
